export default "__VITE_ASSET__hMn0evEI__"